<template>
<vue-apex-charts

    :options="chartOptions"
    :series="series"
    @dataPointSelection="handleClick"
    :height="height"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    VueApexCharts
  },
  props:{
    title:{
        type: String,
        default:'Default Title'
    },
    chartId:{
        type:String,
        required:true
    },
    series:{
        type: Array,
        default: function () {
            return []
        }
    },
    colors:{
        type: Array,
        default: function () {
            return ['#1f82c4','#6ec6f5']
        }
    },
    height:{
        type: String,
        default:'350'
    }
  },
  data() {
    return {
          chartOptions: {
            colors: this.colors,
            plotOptions: {
                treemap: {
                    distributed: true,
                    enableShades: false
                }
            },
            legend: {
              show: false
            },
            chart: {
              id:this.chartId,
              height: '350',
              type: 'treemap'
            },
            /* title: {
              show: false,
              text: this.title
            } */
          }
    }
  },
  methods: {
      handleClick(event, chartContext, config) {
      this.$emit('clickSquare', config)
    }
  },
}
</script>

<style>
</style>